// The client side of /api/interactions (BUILD-BRIEF §4, §6 — interactions agent).
import { request, qs } from './client.js';
import type { InteractionDetail, InteractionKind, ListResponse, ParticipantInput } from '../../shared/types.js';

export interface ListInteractionsParams {
  person_id?: number | null;
  organisation_id?: number | null;
  kind?: InteractionKind | null;
  limit?: number | null;
  q?: string | null;
}

export function listInteractions(params: ListInteractionsParams = {}): Promise<ListResponse<InteractionDetail>> {
  return request(`/interactions${qs(params as Record<string, string | number | boolean | null | undefined>)}`);
}

export function getInteraction(id: number): Promise<InteractionDetail> {
  return request(`/interactions/${id}`);
}

export interface CreateInteractionInput {
  kind: InteractionKind;
  occurred_on: string;
  occurred_at?: string | null;
  date_confirmed?: boolean;
  title: string;
  summary?: string | null;
  body?: string | null;
  organisation_id?: number | null;
  source_kind?: string | null;
  source_ref?: string | null;
  thread_id?: string | null;
  participants?: ParticipantInput[];
}

export function createInteraction(input: CreateInteractionInput): Promise<InteractionDetail> {
  return request('/interactions', { method: 'POST', body: JSON.stringify(input) });
}

export function updateInteraction(id: number, patch: Partial<CreateInteractionInput>): Promise<InteractionDetail> {
  return request(`/interactions/${id}`, { method: 'PATCH', body: JSON.stringify(patch) });
}
